module.exports = __webpack_public_path__ + "img/user_img.1fab2e59.png";